import { useState } from 'react';
import { faqItems } from '@/mocks/faq';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <SchemaOrg type="FAQPage" data={faqSchema} />
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs bg-primary-100 text-primary-700 rounded-full mb-3 whitespace-nowrap">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            关于国产传媒
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            了解更多关于平台的常见问题解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => toggle(index)}
              >
                <span className="text-sm font-semibold text-foreground-800 pr-4">{item.question}</span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}